import { Tabs } from 'antd' // Button
import React from 'react' // , { useState } 
import PadContainer from '../../../components/PadContainer'
import BlogTabs from './blogsTab'
import BlogCatTab from './blogCat'

function BlogsManagementPage() {

  const items = [
    {
      key: '1',
      label: 'Blog',
      children: <BlogTabs />,
    },
    {
      key: '2',
      label: 'Blog Categories',
      children: <BlogCatTab />,
    },
  ];
  return (
    <PadContainer className="space-y-1">     
      <div className='w-full bg-white rounded-lg border border-[#E4E7EC]'>
        <Tabs defaultActiveKey="1" type='card' size='large' items={items} />
      </div>
    </PadContainer>
  )
}

export default BlogsManagementPage